/* eslint-disable*/
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Filter } from 'lucide-react';
import moment from 'moment';
import analyticsAction from '../../../../Actions/analytics.actions';
import { featureList, filtersInfoChip, useQuery } from '../../../../Helpers';
import styles from './AiProductionHistory.module.scss';
import AiOutwardingListTable from './AiProductionListTable';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';
import { Button } from '@/Components/ui/button';

const options = [
	{
		label: 'Product Name',
		value: 'productName',
		placeholder: 'Search by Product Name',
	},
	{
		label: 'Order ID',
		value: 'orderId',
		placeholder: 'Search by Order ID',
	},
	{
		label: 'Item ID',
		value: 'itemId',
		placeholder: 'Search by Item ID',
	},
];
const dateTypeArr = [
	{
		label: 'Scan Date',
		value: 'createdAt',
	},
	{
		label: 'Plan Date',
		value: 'planDate',
	}
];


const filtersInfo = {
	header: {
		store: false,
		date: false,
		product: false,
		process: false,
		statusAndTypes: false,
	},
	store: {
		show: true,
		multiSelect: true,
		text: 'Store',
	},
	filteredStore: {
		show: true,
		multiSelect: true,
		text: 'From Outlet',
	},
	brand: {
		show: true,
		text: 'Select Brand',
	},
	productWithVariants: {
		show: true,
		text: 'Search Products',
	},
	dateRangeWithType: {
		text: 'Execution Time',
		show: true,
	},
	timeType: {
		text: 'Date Time Type',
		show: true,
	},
	skuType: {
		show: true,
		text: 'Select SKU Type',
		multiSelect: true,
	},
	allProcessType: {
		show: true,
		multiSelect: true,
	},
	duplicate: {
		show: true,
		text: 'Duplicate',
		list: featureList,
	},
	validation: {
		show: true,
		text: 'Validation',
		list: featureList,
	},
	identified: {
		show: true,
		text: 'Identified',
		list: featureList,
	},
	feature: {
		show: true,
		text: 'Feature',
		list: featureList,
	},
};

const exportInfo = {
	showExportBtn: true,
};

const AiProductionHistory = (props) => {
	const {
		data,
		setQCSearchResults,
	} = props;

	const query = useQuery();
	const dispatch = useDispatch();
	const [filters, setFilters] = useState({});
	const [search, setSearchValue] = useState({});
	const flag = query.get('flag');

	const generateData = () => {
		const filteredData = data?.filter((ele) => {
			if (search?.searchValue) {
				return (ele?.ProductName?.toLowerCase().trim().includes(search?.searchValue?.toLowerCase().trim()) ||
					ele?.OrderId?.toLowerCase().trim().includes(search?.searchValue?.toLowerCase().trim()) ||
					ele?.itemId?.toLowerCase().trim().includes(search?.searchValue?.toLowerCase().trim()));
			}
			return ele;
		});
		setQCSearchResults(
			search?.value,
			filteredData,
			search?.searchValue
		);
		return filteredData;
	};

	useEffect(() => {
		if (!flag) {
			dispatch(drawerActions.toggleFiltersDrawer(true));
		}
		return () => {
			dispatch(analyticsAction.resetInventoryAnalyticsState({
				entity: 'AI_PRODUCTION_ANALYSIS',
				method: 'LIST_DATA',
				data: [],
			}));
		}
	}, []);

	function fetchProductionHistory(filterValue) {
		console.log(filterValue, 'filterValue');
		setFilters(filterValue);
		const req = {
			data: {
				brandFilter: filterValue?.brandFilter?.id ? [filterValue?.brandFilter?.id] : [],
				storeFilter: filterValue?.multiStore?.id ? filterValue?.multiStore?.id : [],
				qcType: 'PRODUCTION',
				fromStoreFilter: filterValue?.filterMultiStore?.id ? filterValue?.filterMultiStore?.id : [],
				processTypes: filterValue?.allProcessTypeMulti?.id ? filterValue?.allProcessTypeMulti?.id : [],
				skuTypes: filterValue?.skuTypeMulti?.includes('ALL') ? [] : filterValue?.skuTypeMulti,
				duplicate: filterValue?.duplicate === 'all' ? null : filterValue?.duplicate,
				validation: filterValue?.validation === 'all' ? null : filterValue?.validation,
				identified: filterValue?.identified === 'all' ? null : filterValue?.identified,
				feature: filterValue?.feature === 'all' ? null : filterValue?.feature,
				dateRangeFilter: {
					from: moment(filterValue?.dateRange?.from).format('YYYY-MM-DD'),
					to: moment(filterValue?.dateRange?.to).format('YYYY-MM-DD'),
				},
				timeType: filterValue?.timeType?.value,
				variantIds: [...new Set(filterValue?.productWithVariant?.productData?.flatMap(item => item?.variantIds) || [])],
				allProcessTypeMulti: filterValue?.allProcessTypeMulti?.id ? filterValue?.allProcessTypeMulti?.id : [],
			},
		};
		dispatch(analyticsAction.gateway({
			entity: 'AI_PRODUCTION_ANALYSIS',
			req,
			method: 'LIST_DATA',
		}));
	}

	return (
		<div className={styles.root}>
			<ImagesFinder
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				onSubmit={fetchProductionHistory}
				avoidInitialCall={!flag}
				allStoreOption={false}
				timeTypeArray={dateTypeArr}
			/>
			<p className='text-lg font-bold m-1'>AI Production History</p>
			<div
				className='flex flex-1 items-baseline gap-3'
			>
				<div className='flex-1 min-w-0'>
					<GlobalSearch
						dropDownOptions={options}
						setSelectedValue={setSearchValue}
					/>
				</div>
				<span className='text-sm text-gray-500 font-bold'>
					Total Records:
					{data?.length}
				</span>
				<Button
					onClick={(e) => {
						dispatch(drawerActions.toggleFiltersDrawer(true, {
							handleDataExport: (exportFilters) => {
								const exportReq = {
									brandFilter: exportFilters?.brandFilter?.id ? [exportFilters?.brandFilter?.id] : [],
									storeFilter: exportFilters?.multiStore?.id ? exportFilters?.multiStore?.id : [],
									fromStoreFilter: exportFilters?.filterMultiStore?.id ? exportFilters?.filterMultiStore?.id : [],
									processTypes: exportFilters?.allProcessTypeMulti?.id ? exportFilters?.allProcessTypeMulti?.id : [],
									skuTypes: exportFilters?.skuTypeMulti,
									duplicate: exportFilters?.duplicate === 'all' ? null : exportFilters?.duplicate,
									validation: exportFilters?.validation === 'all' ? null : exportFilters?.validation,
									identified: exportFilters?.identified === 'all' ? null : exportFilters?.identified,
									feature: exportFilters?.feature === 'all' ? null : exportFilters?.feature,
									dateRangeFilter: {
										from: moment(exportFilters?.dateRange?.from).format('YYYY-MM-DD'),
										to: moment(exportFilters?.dateRange?.to).format('YYYY-MM-DD'),
									},
									variantIds: [...new Set(exportFilters?.productWithVariant?.productData?.flatMap(item => item?.variantIds) || [])],
									allProcessTypeMulti: exportFilters?.allProcessTypeMulti?.id ? exportFilters?.allProcessTypeMulti?.id : [],
								};
								dispatch(analyticsAction?.exportAiProductionAnalytics(exportReq));
							},
						}));
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<AiOutwardingListTable
				data={generateData()}
			/>
		</div>
	);
};

AiProductionHistory.defaultProps = {};

const mapStateToProps = (state) => {
	const { LIST_DATA: data } = state.analytics.AI_PRODUCTION_ANALYSIS;
	return {
		data,
	};
};

const mapDispatchToProps = {
	setQCSearchResults: analyticsAction.setQCSearchResults,
};
export default connect(mapStateToProps, mapDispatchToProps)(AiProductionHistory);
